module.exports = __webpack_public_path__ + "static/img/integrated.235dc85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilustration/integrated.png
// module id = KFg9
// module chunks = 1